import React, { useEffect, useState } from 'react';
import { Alert } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import { API_PUBLIC_KEY } from './constants';
import { actions, actionTypes } from '../modules/Auth/_redux/authRedux';
import { JSEncrypt } from "jsencrypt";


export default function AutoLogin() {

    const dispatch = useDispatch();

    const [statusTxt, setStatusTxt] = useState("Redirecting to SSO Login");
    const [status, setStatus] = useState(0);

    const { isAuthorized } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null,
        }), shallowEqual
    );

    const autoLogin = async () => {
        const token = localStorage.getItem("temp_token");
        try {
            dispatch(actions.setSSOStatus({ sso_status: 0 }));
            if (isAuthorized) {
                dispatch(actions.setSSOToken({ sso_token: token }));
            }

            setTimeout(() => {
                const params = { token: token };
                const encrypt = new JSEncrypt();
                encrypt.setPublicKey(API_PUBLIC_KEY);
                const onSuccess = (data) => {
                    if (data["status"] !== 200) {
                        setStatusTxt(data["error"]["message"]);
                        setStatus(data["status"]);
                    } else {
                        setStatusTxt("Logged-in success, redirecting to dashboard...");
                        setStatus(data["status"]);
                        dispatch(actions.setSSOStatus({ sso_status: 200 }));
                    }
                };

                const onError = (data) => {
                    setStatusTxt(
                        "Login error - (Error code:" + data.error.log.response.status + ")"
                    );
                    setStatus(data.error.log.response.statusTxt);
                };

                dispatch({
                    type: actionTypes.SSOLogin,
                    payload: params,
                    onSuccess,
                    onError,
                });
                return;
            }, 50);
        } catch (error) {
            setStatusTxt(error.response["statusTxt"]);
            setStatus(error.response["status"]);
            return error.response;
        }
    };


    useEffect(() => {
        let temp_token = localStorage.getItem("temp_token");
        if (status == 0 && temp_token) {
            autoLogin();
        } 
    }, [status])

    // if (status === 200) {
    //     let redirect_url = localStorage.getItem("redirect_url")
    //     if (redirect_url) {
    //         return (<Redirect from="/sso" to={redirect_url} />)
    //     } else {
    //         return (<Redirect from="/sso" to="/home" />)
    //     }
    // }

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-4">
                    <div className="text-center mt-20">
                        <Alert variant="primary">
                            <h3>{statusTxt}</h3>
                        </Alert>
                    </div>
                </div>
            </div>
        </div>
    )
}
